import React from 'react';
import doctor from '../../../assets/images/doctor.png'
import bgappoint from '../../../assets/images/appointment.png'
import { Link } from 'react-router-dom';

const Makeappointment = () => {
    return (
        <section className=' mt-32 rounded mb-6' style={{ backgroundImage: `url(${bgappoint})` }}>
            <div className="hero " >
                <div className="hero-content flex-col lg:flex-row">
                    <img src={doctor} className="-mt-40  lg:w-1/2" alt='' />
                    <div className='p-6'>
                        <h4 className='text-3xl font-bold text-primary'>Appointment</h4>
                        <h1 className="text-5xl font-bold text-white">Make an appointment Today</h1>
                        <p className="py-6 text-white">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsumis that it has a more-or-less normal distribution of letters,as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page.</p>
                        <Link to='/appointment'><button className="btn btn-primary bg-gradient-to-r from-primary to-secondary text-white">Appointment Here</button></Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Makeappointment;